import { useRoutes } from 'react-router-dom';

import DashboardRoutes from './DashboardRoutes';
import LoginRoutes from './LoginRoutes';
import InitialPage from './InitialPage';
import NotFound from '../pages/Login/NotFound';

export default function AppRoutes() {
    return useRoutes([{ path: '/', element: <InitialPage /> }, { path: '*', element: <NotFound /> }, LoginRoutes, DashboardRoutes]);
}
